import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { store } from "../../app/store";
import { usersApiSlice } from "../users/usersApiSlice";
import { sitesApiSlice } from "../sites/sitesApiSlice";
import { memberApiSlice } from "../members/membersApiSlice";

const Prefetch = () => {
  useEffect(() => {
    store.dispatch(
      usersApiSlice.util.prefetch("getUsers", "usersList", { force: true })
    );
    store.dispatch(
      sitesApiSlice.util.prefetch("getSites", "sitesList", { force: true })
    );
    store.dispatch(
      memberApiSlice.util.prefetch("getMembers", "membersList", { force: true })
    );
  }, []);

  return <Outlet />;
};
export default Prefetch;
